export const headers = [
  {
    text: 'Patente',
    value: 'patente',
    align: 'left',
  },
  {
    text: 'Caso',
    value: 'caso',
    align: 'left',
  },
  {
    text: 'Fecha de Coordinación',
    value: 'fechaCoordinacion',
    align: 'left',
  },
  {
    text: 'Técnico',
    value: 'tecnicoNombre',
    align: 'left',
  },
  {
    text: 'Cliente Contactado?',
    value: 'clienteContactado',
    align: 'left',
  },
  {
    text: 'Estado',
    value: 'estado',
    align: 'left',
  },
  {
    text: 'Id. Visita',
    value: 'identificador',
    align: 'left',
  },
  {
    text: 'Tipo de Visita',
    value: 'tipovisita',
    align: 'left',
  },
  {
    text: 'Fecha de Cierre del Caso',
    value: 'fechaCierre',
    align: 'left',
  },
  {
    text: 'Glosa',
    value: 'glosa',
    align: 'left',
  },
];
